<mat-card-title role="heading" aria-level="2">{{'remove-account.termination' | translate}}</mat-card-title>
<mat-card-content>
  <mat-dialog-actions id="close-button">
    <button mat-raised-button color="primary" (click)="logOut()" aria-label="Close message and return to home" routerLink="/" [mat-dialog-close]="true">{{'remove-account.close' | translate}}</button>
  </mat-dialog-actions>
</mat-card-content>
